import { Button, TextInputFieldController } from '@fukuri-admins/ui/common';
import { useFormContext } from 'react-hook-form';
import { FileInputFieldController } from '~/ui/domain/portal/FileInputFieldController';
import { PortalModal } from '~/ui/domain/portal/Modal';
import { PortalSelect } from '~/ui/domain/portal/select';
import styles from './styles.module.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedFile: File | undefined;
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveFile: () => void;
  onItemTypeChange: (value: 'url' | 'file') => void;
};

export const CreatePortalModalPresentation: React.FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
  selectedFile,
  onFileChange,
  onRemoveFile,
  onItemTypeChange,
}) => {
  const { register } = useFormContext();

  return (
    <PortalModal isOpen={isOpen} onClose={onClose} title='ポータルの新規作成'>
      <form className={styles.formContainer} onSubmit={onConfirm}>
        <PortalSelect name='icon_name' label='アイコン' placeholder='アイコンを選択してください' />
        <TextInputFieldController
          name='title'
          fieldWrapperProps={{
            labelText: '表示名',
            beforeMessage: '全角12文字まで。文字数を超える場合は省略表示されます。',
          }}
          textInput={{
            placeholder: 'ポータル名を入力',
            type: 'text',
          }}
        />

        <div className={styles.itemSection}>
          <span className={styles.itemSectionLabel}>項目</span>

          <label className={styles.radioLabel}>
            <input
              type='radio'
              value='url'
              {...register('item_type')}
              defaultChecked
              onChange={() => onItemTypeChange('url')}
            />
            リンクを追加する
          </label>
          <div className={styles.itemContent}>
            <TextInputFieldController
              name='url'
              fieldWrapperProps={{
                labelText: '',
              }}
              textInput={{
                placeholder: 'https://example.com',
                type: 'url',
              }}
            />
          </div>

          <label className={styles.radioLabel}>
            <input
              type='radio'
              value='file'
              {...register('item_type')}
              onChange={() => onItemTypeChange('file')}
            />
            ファイルを追加する
          </label>
          <div className={styles.itemContent}>
            <FileInputFieldController
              name='file'
              label=''
              accept='application/pdf'
              selectedFile={selectedFile}
              onFileChange={onFileChange}
              onRemoveFile={onRemoveFile}
            />
          </div>
        </div>

        <div className={styles.buttonContainer}>
          <Button variant='outline' onClick={onClose}>
            キャンセル
          </Button>
          <Button variant='primary' type='submit'>
            作成
          </Button>
        </div>
      </form>
    </PortalModal>
  );
};
